import {AbstractStatisticsView} from "./abstract-statistics-view.js";
import template from './cod-statistics-template.html.js';

export class CodStatisticsView extends AbstractStatisticsView {

    fetchDataDelay = 250;

    constructor(props) {
        super(props);
        this.template = template;
    }

    getUrl() {
        return this.paths.get('rest_user_statistics_ongoing_cod', {
            user_id: this.props.user_id,
        });
    }
}
